/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  list constants
 */

// ** NZR & NPR **

// number of listings to display inside of the infinite scroller
export const LIST_LIMIT = 14
export const LISTABLES_API_LIMIT = 20
export const LISTABLES_API_PAGE_LIMIT = 50
export const LISTABLES_API_PAGE_LIMIT_SHORT = 25
export const LISTABLES_API_LIMIT_MAX = 100
export const SIMILAR_LISTABLES_API_LIMIT = 10
export const SHORT_TERM_LISTABLES_API_FIRST_PAGE_LIMIT = 50

// Used for progressive image loading in list items.
// On cold load of list items, we use these COUNT to determine
// whether they are in the view port, and thus, immediately try to load the main image.
// Correct way to do this would be to calculate the view port but for now this will do.
// Should probably be refactored during list optimization.
export const FULL_TYPE_LOAD_COUNT = 4
export const MOBILE_LIST_TYPE_LOAD_COUNT = 8

// ** NPR **

export const LIST_NAME = 'pList'
export const LIST_TYPE = 'list'
export const TILE_TYPE = 'tile'
export const FULL_TYPE = 'full'
